import Image from 'next/image';
import { Toman } from '@/components/svg-symbols/icons';
import { toNumberCommas } from '@/utils/string-helpers';
import './style.css';
interface Props {
  name: string;
  basePrice: number;
  salesPrice: number;
  discountPercent: number;
  image: string;
  brand: string;
}
export default function BirthdayProductCard({
  name,
  basePrice,
  salesPrice,
  discountPercent,
  image,
  brand
}: Props) {
  const hasDiscount = discountPercent > 0;
  return <div className='birthday-product-card relative isolate flex h-full w-full flex-col' data-sentry-component="BirthdayProductCard" data-sentry-source-file="birthday-product-card.tsx">
            {hasDiscount && <span className='birthday-product-card-discount-badge absolute left-2 top-2 isolate z-20 px-2 text-caption-12 font-bold text-white lg:left-3 lg:top-3 lg:text-body-14'>
                    {discountPercent}٪
                </span>}

            <Image src={image} alt={name} width={224} height={224} unoptimized className='birthday-product-card-image relative z-10 h-35 w-full object-contain lg:h-56' data-sentry-element="Image" data-sentry-source-file="birthday-product-card.tsx" />

            <div className='birthday-product-card-footer relative z-10 flex grow flex-col bg-[var(--landing-bg)] text-white'>
                <div className='flex grow flex-col gap-1 px-1.5 py-2 lg:px-2.5'>
                    <span className='text-caption-12 text-text-lightGray lg:text-body-14'>{brand}</span>
                    <h3 className='line-clamp-2 text-caption-12 font-medium lg:text-body-14'>{name}</h3>
                </div>

                <div className='grid grid-cols-2 items-center justify-center border-t border-white'>
                    <div className='flex items-center justify-center gap-1 border-l border-white bg-primary-main px-1.5 py-1.5 text-center lg:px-2 lg:py-3'>
                        <span className='text-caption-10 font-medium lg:text-body-16 lg:font-medium'>
                            {toNumberCommas(salesPrice)}
                        </span>
                        <Toman className='h-3.5 w-3.5 lg:h-6 lg:w-6' data-sentry-element="Toman" data-sentry-source-file="birthday-product-card.tsx" />
                    </div>

                    <div className='px-1.5 py-1.5 text-center text-caption-10 line-through lg:px-2 lg:py-3 lg:text-body-16'>
                        {toNumberCommas(basePrice)}
                    </div>
                </div>
            </div>
        </div>;
}